import Swiper from 'swiper'
import { EffectFade } from 'swiper/modules'
import 'swiper/swiper-bundle.css'

const initNewsGallery = (slider) => {
  if (slider.dataset.galleryReady) return
  const swiperEl = slider.querySelector('.swiper')
  if (!swiperEl) return
  slider.dataset.galleryReady = 'true'

  const status = slider.querySelector('.swiper-status')
  const total = slider.querySelectorAll('.swiper-slide').length

  const updateStatus = (swiper) => {
    if (!status) return
    status.textContent = `${swiper.activeIndex + 1}/${total}`
  }

  const options = {
    modules: [EffectFade],
    effect: 'fade',
    // crossFade:false keeps passed slides stacked at full opacity beneath
    // the active one — slides need an opaque background (see 80_teasers.sass)
    // wherever the image doesn't cover the whole slide
    fadeEffect: { crossFade: false },
    speed: 200,
    loop: false,
    // Small teaser uses a fixed-ratio image box (see 80_teasers.sass), so it must
    // NOT autoHeight to each slide; the large teaser still sizes to its image.
    autoHeight: !slider.closest('.teaser-news-small'),
    allowTouchMove: true,
    slidesPerView: 1,
    on: {
      init: updateStatus,
      slideChange: updateStatus,
      click: (swiper) => {
        if (swiper.activeIndex >= total - 1) {
          swiper.slideTo(0)
        } else {
          swiper.slideNext()
        }
      },
    },
  }

  new Swiper(swiperEl, options)
}

// Initialise every gallery within `root`; safe to call again for appended
// content (already-initialised sliders are skipped via a dataset flag).
export const initNewsGalleries = (root = document) => {
  root.querySelectorAll('[data-news-gallery]').forEach(initNewsGallery)
}

initNewsGalleries()
